// extracted by mini-css-extract-plugin
module.exports = {"blogCategories":"BlogCategories_blogCategories__sE8Tg","active":"BlogCategories_active__3g3z8"};